module.exports = __webpack_public_path__ + "img/1-01.58dc29c0.png";